
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { GetStaticPropsContext } from 'next/types';
import { Makeswift, Page as MakeswiftPage, PageProps as MakeswiftPageProps } from '@makeswift/runtime/next';
import { SWRConfig } from 'swr';
import { ShowcaseFeedDocument, ShowcaseOrder } from '@/generated/contentful';
import { client as contentful } from '@/lib/contentful/client';
import { serializeCacheKey } from '@/lib/contentful/utils';
import { getPageSnapshot } from '@/lib/makeswift/client';
import '@/lib/makeswift/components';
import { LIMIT } from '@/components/Contentful/entries/Showcase/ShowcaseFeed/ShowcaseFeed';
import { ShowcaseMeta } from '@/components/Contentful/entries/Showcase/ShowcaseMeta';
import { getShowcaseCategories } from '@/components/Contentful/entries/Showcase/helpers/getShowcaseCategories';
import { PreviewToast } from '@/components/PreviewToast';
type Props = {
    fallback: {
        [key: string]: unknown;
    };
    preview: boolean;
} & MakeswiftPageProps;
export default function Page({ snapshot, fallback, preview }: Props) {
    return (<SWRConfig value={{ fallback }}>
			<PreviewToast preview={preview}/>
			<ShowcaseMeta>
				<MakeswiftPage snapshot={snapshot}/>
			</ShowcaseMeta>
		</SWRConfig>);
}
async function getStaticProps({ previewData, preview, params, locale }: GetStaticPropsContext<{
    slug: string[] | undefined;
}, {
    makeswift: boolean;
}>) {
    const isMakeSwiftPreview = previewData?.makeswift == true;
    const getSlug = () => {
        const slug = params?.slug?.at?.(-1);
        if (slug && !slug.startsWith('?'))
            return slug;
        return 'showcase';
    };
    const slug = getSlug();
    if (slug == null)
        throw new Error('"slug" URL parameter must be defined.');
    const categories = await getShowcaseCategories(0, 100, locale);
    const category = categories?.find((item) => item?.slug === slug) ??
        categories?.find((item) => item?.slug_en_US === slug);
    if (!category?.slug && !isMakeSwiftPreview) {
        console.warn(`No showcase category found for slug ${slug} and locale ${locale}`);
        return { notFound: true, revalidate: 3600 };
    }
    if (params?.slug?.length === 1 && category?.parentCategory?.slug) {
        console.warn(`Trying to access subcategory ${category?.slug} without parent category ${category?.parentCategory?.slug} in URL.`);
        return { notFound: true, revalidate: 3600 };
    }
    const showcase = await contentful().request(ShowcaseFeedDocument, {
        where: { category: { slug: category?.slug }, image_exists: true },
        order: [ShowcaseOrder.TitleAsc],
        limit: LIMIT,
        skip: 0,
        locale
    });
    const snapshot = await getPageSnapshot({
        pathname: '/showcase/__template__',
        isMakeswiftPreview: previewData?.makeswift == true,
        previewData,
        locale,
        timeout: {
            ms: 10000,
            message: `Timeout request getPageSnapshot for "/showcase/__template__" – Locale: ${locale}`
        }
    });
    if (snapshot == null) {
        return { notFound: true, revalidate: 3600 };
    }
    return {
        props: {
            snapshot,
            fallback: {
                [serializeCacheKey('showcaseFeed', {
                    category: slug,
                    limit: LIMIT,
                    skip: 0,
                    locale
                })]: showcase,
                [serializeCacheKey('showcaseCategory', { limit: 100, locale })]: categories
            },
            previewMode: Makeswift.getPreviewMode(previewData),
            preview: Boolean(preview),
            pageId: category?.sys?.id
        },
        revalidate: 3600
    };
}
export async function getStaticPaths() {
    return {
        paths: [],
        fallback: 'blocking'
    };
}

    async function __Next_Translate__getStaticProps__1967e598384__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/showcase/[[...slug]]',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || (() => Promise.resolve({})),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1967e598384__ as getStaticProps }
  